var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M19.833 3.215v5.852c0 .793 0 1.19.155 1.493.136.266.352.483.619.62.303.154.7.154 1.493.154h5.852m.381 2.816v10.217c0 2.38 0 3.57-.463 4.48a4.25 4.25 0 0 1-1.857 1.857c-.91.463-2.1.463-4.48.463h-9.066c-2.38 0-3.57 0-4.48-.463a4.25 4.25 0 0 1-1.857-1.858c-.463-.909-.463-2.099-.463-4.48V9.635c0-2.38 0-3.57.463-4.48a4.25 4.25 0 0 1 1.857-1.857c.91-.464 2.1-.464 4.48-.464h4.55c1.04 0 1.559 0 2.048.118a4.3 4.3 0 0 1 1.229.509c.428.263.796.63 1.531 1.365l4.517 4.517c.735.735 1.102 1.102 1.365 1.531.233.38.405.795.509 1.229.117.489.117 1.009.117 2.048"
  })));
};
export default SvgFile;